<template>
    <div class="rounded">
        <div class="flex items-center mb-1">
            <div class="flex-grow">
                <div
                    class="whitespace-pre-line text-lg m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10 resize-none"
                    v-text="name"
                ></div>
            </div>
        </div>
        <application-for-payment-task v-for="task in section.tasks" :key="task.id"
                                      :measurable="true"
                                      :readonly="readonly"
                                      @updated="$emit('updated')"
                                      :task="task"></application-for-payment-task>

        <div class="py-2"></div>
    </div>
</template>

<script>
import ApplicationForPaymentTask from "./ApplicationForPaymentTask.vue";

export default {
    components: {
        ApplicationForPaymentTask,
    },
    props: {
        section: Object,
        readonly: false,
    },
    data() {
        return {
            name: this.section.name,
        }
    },
    computed: {},
    methods: {},
}
</script>
